import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { RouteId } from "../enums/env/routes-id-enum";
import { RouteEnv } from "../interfaces/env/RouteEnv";
import { MainRoute } from "../models/MainRoute";
import { RightService } from "./right.service";

@Injectable({
  providedIn: 'root',
})
export class RoutingService {

  constructor(private rightService: RightService) {
  }

  public static getRoute(routeId: RouteId): MainRoute {
    return new MainRoute(RoutingService.searchRoute(routeId), routeId);
  }

  public getRoutesLeftMenu(): MainRoute[] {
    const listRoute = [];
    environment.core.routes.forEach(r => {
      if(r.id === RouteId.TERMINALS || r.id === RouteId.CLIENTS || r.id === RouteId.CARRIERS || r.id === RouteId.USERS || r.id === RouteId.SETTINGS) {
        const canAccessAdmin: boolean = this.rightService.canAccessAdministration();
        if(r.enabled && canAccessAdmin) {
          listRoute.push(r);
        }
      }
      if(r.id === RouteId.TANKS || r.id === RouteId.STATIONS || r.id === RouteId.PLANNING) {
        const canAccessLogistic: boolean = this.rightService.canAccessLogistic();
        if(r.enabled && canAccessLogistic) {
          listRoute.push(r);
        }
      }
      if(r.id === RouteId.DELIVERIES) {
        const canAccessDeliveries: boolean = this.rightService.canAccessDeliveries();
        if(r.enabled && canAccessDeliveries) {
          listRoute.push(r);
        }
      }
      if(r.id === RouteId.PREINVOICE_CARRIER || r.id === RouteId.INVOICE || r.id === RouteId.CHARGES_SWAP) {
        const canAccessFinance: boolean = this.rightService.canAccessFinance();
        if(r.enabled && canAccessFinance) {
          listRoute.push(r);
        }
      }

    });

    return listRoute;
  }

  public static getPathRoute(routeId: RouteId): string {
    return RoutingService.getRoute(routeId).path;
  }

  private static searchRoute(routeId: RouteId): RouteEnv {
    let found: RouteEnv = null;
    if (typeof(routeId) === 'string') {
      routeId = parseInt(routeId);
    }
    
    environment.core.routes.forEach(r => {
      if (r.id === routeId) {
        found = r;
      } else if (r.tabs) {
        const sub = r.tabs.find(sub => sub.id === routeId);
        if (sub) {
          found = sub;
        }
      }
    });

    return found;
  }
}
